var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import React, { useState, useEffect } from 'react';
import LocalStorageUtils from 'src/utils/localStorage.utils';
import { LocalStorageKeyEnum } from '@reference-data/local-storage-key.enum';
import { useDispatch } from 'react-redux';
export const Div2SwitcherComponent = () => {
    const dispatch = useDispatch();
    const [isOpen, setIsOpen] = useState(false);
    const [activeDiv2, setActiveDiv2] = useState('eur');
    const [DIV2, setDIV2] = useState([]);
    const [loading, setLoading] = useState(true);
    useEffect(() => {
        LocalStorageUtils.getValueFromLocalStorage(LocalStorageKeyEnum.VALUE_TYPE2)
            .then((saved) => {
            if (!saved)
                return;
            const clean = String(saved).toLowerCase();
            setActiveDiv2(clean);
        })
            .catch(() => { });
    }, []);
    useEffect(() => {
        const fetchCurrencies = () => __awaiter(void 0, void 0, void 0, function* () {
            try {
                const response = yield fetch('https://timeapp.foundation/divlist.php');
                const data = yield response.json();
                //    // console.log("[TEST] props: " + JSON.stringify(data, null, 2));
                const currencyObj = data[0];
                const list = Object.keys(currencyObj).map(key => ({
                    key: key.toLowerCase(),
                    name: currencyObj[key].trim()
                }));
                setDIV2(list);
                setLoading(false);
            }
            catch (err) {
                //    console.error('Errore caricamento divise', err);
                setLoading(false);
            }
        });
        fetchCurrencies();
    }, []);
    const selectDiv2 = (div2Key) => __awaiter(void 0, void 0, void 0, function* () {
        const lowerKey2 = div2Key.toLowerCase();
        setActiveDiv2(lowerKey2);
        yield LocalStorageUtils.saveValueInLocalStorage(LocalStorageKeyEnum.VALUE_TYPE2, lowerKey2);
        setIsOpen(false);
    });
    if (loading || DIV2.length === 0) {
        return (React.createElement("div", { className: "blockchain-switcher" },
            React.createElement("span", { className: "chain-name" }, "Loading...")));
    }
    const current = DIV2.find(c => c.key === activeDiv2) || DIV2[0];
    return (React.createElement("div", { className: "blockchain-switcher", onClick: () => setIsOpen(!isOpen) },
        React.createElement("span", { className: "chain-name" },
            " ",
            current.key,
            " "),
        React.createElement("span", { className: "currency-name" },
            " ",
            current.name),
        React.createElement("svg", { className: `dropdown-arrow ${isOpen ? 'open' : ''}`, viewBox: "0 0 24 24" },
            React.createElement("path", { d: "M7 10l5 5 5-5z", fill: "currentColor" })),
        isOpen && (React.createElement("div", { className: "dropdown-menu", onClick: (e) => e.stopPropagation() }, DIV2.map((div2) => (React.createElement("div", { key: div2.key, onClick: () => selectDiv2(div2.key) },
            React.createElement("span", { className: "currency-code" }, div2.key),
            React.createElement("span", { className: "currency-name" }, div2.name),
            div2.key === activeDiv2 && React.createElement("span", { className: "check" }, "\u2713"))))))));
};
